// extracted by mini-css-extract-plugin
export default {"listContainer":"dashboardList_listContainer__CctdQ","listItem":"dashboardList_listItem__eOHrQ"};